import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import SweetAlert from 'react-bootstrap-sweetalert';
import { toast } from 'react-toastify';
import classNames from 'classnames';
import { Tooltip } from '@material-ui/core';
import { Info } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import buttonsStyle from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { get, post, put, remove } from 'helpers/apiHelpers';
import { combineStyles, isGranted } from 'helpers/helpers';
import { ROLE_EDIT_SMSING } from 'helpers/roles';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';

import EndOfDietReminders from './EndOfDietReminders';

class Reminders extends Component {
  state = {
    smsing: {
      // eslint-disable-next-line camelcase -- FIXME
      end_of_diet_reminder_config: [],
    },
    checkboxState: false,
    confirmModal: null,
  };

  componentDidMount() {
    Promise.all([
      get('sms-reminders?pagination=false'),
      get(`brands/${this.props.brand}/smsing`),
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    ]).then(([reminders, smsing]) => {
      this.setState({
        smsing: {
          // eslint-disable-next-line camelcase -- FIXME
          end_of_diet_reminder_config: reminders['hydra:member'].map(
            config => ({
              ...config,
              hasChanged: false,
            })
          ),
        },
        checkboxState: smsing.smsing.end_of_diet_reminder,
      });
    });
  }

  renderAlert = (onConfirm, onCancel) => {
    const { t, classes } = this.props;

    const confirmModal = (
      <SweetAlert
        warning={true}
        title={t('reminders.mailReminders.deleteMessage')}
        onConfirm={() => onConfirm()}
        onCancel={() => onCancel()}
        confirmBtnCssClass={classNames(classes.button, classes.success)}
        cancelBtnCssClass={classNames(classes.button, classes.danger)}
        confirmBtnText={t('common.shared.yes')}
        cancelBtnText={t('common.shared.no')}
        showCancel={true}
      />
    );

    this.setState({ confirmModal });
  };

  render() {
    const { t } = this.props;

    return (
      <Card>
        <CardBody>
          {this.state.confirmModal}
          {isGranted(ROLE_EDIT_SMSING) && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <LabeledCheckbox
                label={t('notify.notifyUsers')}
                checked={this.state.checkboxState}
                onChange={() => {
                  const newCheckboxState = !this.state.checkboxState;

                  this.setState({ checkboxState: newCheckboxState });

                  put(`brands/${this.props.brand}/smsing`, {
                    // eslint-disable-next-line camelcase -- FIXME
                    smsing: { end_of_diet_reminder: newCheckboxState },
                    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
                  }).then(() => {
                    toast.success(t('notify.changesSaved'));
                  });
                }}
              />
              <Tooltip
                title={t('$*smsReminder.EndOfDietSMSReminder.tooltip')}
                placement="right"
              >
                <Info style={{ fontSize: 16 }} />
              </Tooltip>
            </div>
          )}
          <EndOfDietReminders
            smsing={this.state.smsing}
            addRow={() => {
              const newRow = {
                hours: 0,
                template: '',
                ignoreClientMarketingAgreement: false,
              };

              this.setState(prevState => ({
                ...prevState,
                smsing: {
                  ...prevState.smsing,
                  // eslint-disable-next-line camelcase -- FIXME
                  end_of_diet_reminder_config:
                    prevState.smsing.end_of_diet_reminder_config.concat(newRow),
                },
              }));
            }}
            saveRow={index => {
              const row = this.state.smsing.end_of_diet_reminder_config[index];

              if (
                !row.acceptedClientMarketingAgreement &&
                !row.ignoreClientMarketingAgreement
              ) {
                toast.error(t('notify.cannotSavePleaseCheckOneOption'));
              } else {
                const action = row.id ? put : post;

                action(action === put ? row['@id'] : 'sms-reminders', {
                  ...row,
                  // eslint-disable-next-line radix -- FIXME
                  hours: parseInt(row.hours),
                  ignoreClientMarketingAgreement:
                    row.ignoreClientMarketingAgreement,
                  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
                }).then(
                  () => {
                    const { smsing } = this.state;

                    smsing.end_of_diet_reminder_config[
                      index
                    ].hasChanged = false;

                    this.setState({ smsing });

                    toast.success(t('notify.changesSaved'));
                  },
                  () => toast.error(t('notify.cannotSave'))
                );
              }
            }}
            removeRow={index => {
              this.renderAlert(
                () => {
                  const configAfterDelete =
                    this.state.smsing.end_of_diet_reminder_config.filter(
                      (el, ind) => ind !== index
                    );
                  const row =
                    this.state.smsing.end_of_diet_reminder_config[index];
                  // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
                  row.id && remove(row['@id']);

                  this.setState(prevState => ({
                    ...prevState,
                    confirmModal: false,
                    smsing: {
                      ...prevState.smsing,
                      // eslint-disable-next-line camelcase -- FIXME
                      end_of_diet_reminder_config: configAfterDelete,
                    },
                  }));
                },
                () => this.setState({ confirmModal: false })
              );
            }}
            handlePrefix={(event, index) => {
              const { smsing } = this.state;
              const { value } = event.target;
              const configValue =
                smsing.end_of_diet_reminder_config[index].hours;
              let newNumber;

              if (value === '0') {
                newNumber = 0;
              } else if (value === '-') {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
                configValue > 0
                  ? (newNumber = -1 * configValue)
                  : (newNumber = configValue);
              } else {
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- FIXME
                configValue < 0
                  ? (newNumber = -1 * configValue)
                  : (newNumber = configValue);
              }

              smsing.end_of_diet_reminder_config[index].hours = newNumber;

              this.setState({ smsing });
            }}
            handleRow={(event, index) => {
              const { name, value } = event.target;
              const { smsing } = this.state;

              smsing.end_of_diet_reminder_config[index][name] = value;
              smsing.end_of_diet_reminder_config[index].hasChanged = true;

              this.setState({ smsing });
            }}
            handleEditor={(code, name, index) => {
              const { smsing } = this.state;

              smsing.end_of_diet_reminder_config[index][name] = code;
              smsing.end_of_diet_reminder_config[index].hasChanged = true;

              this.setState({ smsing });
            }}
            handleToggle={(event, index) => {
              const { name } = event.target;
              const { smsing } = this.state;

              smsing.end_of_diet_reminder_config[index][name] =
                !smsing.end_of_diet_reminder_config[index][name];
              smsing.end_of_diet_reminder_config[index].hasChanged = true;

              this.setState({ smsing });
            }}
          />
        </CardBody>
      </Card>
    );
  }
}

const combinedStyles = combineStyles(
  extendedFormsStyle,
  buttonsStyle,
  sweetAlertStyle
);

const mapStateToProps = state => ({
  brand: state.Auth.selectedBrand,
});

export default connect(
  mapStateToProps,
  null
)(withStyles(combinedStyles)(withTranslation()(Reminders)));
